<div class="assign-modal">
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <i class="fa fa-times close-btn" (click)="cancel()"></i>
  </div>

  <div class="modal-body">
    <div class="panel panel-default">
      <div class="panel-heading">Filters:</div>
      <div class="panel-body">

        <!-- User Search -->
        <div class="form-group">
          <label>User Assign:</label>
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search by email or name"
                   [(ngModel)]="searchText" (input)="onSearch()">
            <span class="input-group-addon">
              @if (searching) {
<i class="fa fa-spinner fa-pulse"></i>
}
              @if (!searching) {
<i class="fa fa-search"></i>
}
            </span>
          </div>
          @if (searchResults.length > 0) {
<div class="search-dropdown">
            @for (user of searchResults; track $index) {
<a class="search-item" (click)="selectUser(user)">
              {{ user.NAME || user.name }}
            </a>
}
          </div>
}
          @if (noResults) {
<div class="no-results-badge">
            <i class="fa fa-times"></i> No Results Found
          </div>
}
        </div>

        <!-- Assigned Users List -->
        <div class="form-group assigned-section">
          <label>Assigned Users:</label>
          <div class="well-body">
            @for (user of assignedUsers; track $index; let i = $index) {
<div class="user-label-group">
              <i class="fa fa-user"></i>
              <span class="label-button">{{ user.NAME || user.name }}</span>
              <i class="fa fa-times btn-remove" (click)="removeUser(user, i)"></i>
            </div>
}
            @if (assignedUsers.length === 0) {
<div class="no-users-text">No users selected</div>
}
          </div>
        </div>

        <!-- Description -->
        <div class="form-group">
          <label>Description:</label>
          <textarea class="form-control" [(ngModel)]="description" rows="3"></textarea>
        </div>

      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-info btn-sm" (click)="save()"
            [disabled]="assignedUsers.length === 0 || saving">
      Save @if (saving) {
<i class="fa fa-spinner fa-pulse"></i>
}
    </button>
    <button class="btn btn-warning btn-sm" (click)="cancel()">Cancel</button>
  </div>
</div>
